import React, { useState } from "react";
import { AppBar, Toolbar, Button, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { KeyboardArrowDown as KeyboardArrowDownIcon } from "@mui/icons-material";
import Sidebar from "./Sidebar";
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: "none",
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  justifyContent: "flex-start",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.primary,
  "&:not(:last-child)": {
    marginRight: theme.spacing(2),
  },
}));

const ChevronIcon = styled(KeyboardArrowDownIcon)(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));

const Subheader = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <React.Fragment>
      <StyledAppBar position="static">
        <StyledToolbar>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <StyledButton onClick={toggleSidebar}>
              All Categories
              <ChevronIcon fontSize="small" />
            </StyledButton>
          </Box>
          {/* Links to navigate to "/all-products" */}
          <Link to="/all-products" style={{ textDecoration: 'none' }}>
            <StyledButton>Products</StyledButton>
          </Link>
          <Link to="/bestselling" style={{ textDecoration: 'none' }}>
            <StyledButton>Best Selling</StyledButton>
          </Link>
          <Link to="/featuredproducts" style={{ textDecoration: 'none' }}>
            <StyledButton>Featured Products</StyledButton>
          </Link>
          <Link to="/newarrival" style={{ textDecoration: 'none' }}>
            <StyledButton>New Arrival</StyledButton>
          </Link>
          <Link to="/popularbooks" style={{ textDecoration: 'none' }}>
            <StyledButton>Popular Books</StyledButton>
          </Link>
        </StyledToolbar>
      </StyledAppBar>
      <Sidebar open={sidebarOpen} onClose={toggleSidebar} />
    </React.Fragment>
  );
};

export default Subheader;
